import { lazy } from 'react';

const E2EDetailPanelHarnessPage = lazy(() => import('../pages/E2EDetailPanelHarnessPage'));
const E2EDetailPanelAutoHydrateHarnessPage = lazy(() => import('../pages/E2EDetailPanelAutoHydrateHarnessPage'));
const E2EDetailPanelUtcBoundaryHarnessPage = lazy(() => import('../pages/E2EDetailPanelUtcBoundaryHarnessPage'));
const E2EDetailDrawerHarnessPage = lazy(() => import('../pages/E2EDetailDrawerHarnessPage'));
const E2EResultsTableHarnessPage = lazy(() => import('../pages/E2EResultsTableHarnessPage'));
const E2EProductSelectionsHarnessPage = lazy(() => import('../pages/E2EProductSelectionsHarnessPage'));
const E2ESyntheticCancelHarnessPage = lazy(() => import('../pages/E2ESyntheticCancelHarnessPage'));

/**
 * These harness routes exist to support automated browser tests against a local dev/test app.
 * They should never be user-toggleable in a production build.
 */
export const areE2ERoutesEnabled = (env = import.meta.env) => Boolean(env?.DEV || env?.MODE === 'test');

export const e2ePageRoutes = [
  { path: '__e2e/detail-panel', component: E2EDetailPanelHarnessPage },
  { path: '__e2e/detail-panel-auto-hydrate', component: E2EDetailPanelAutoHydrateHarnessPage },
  { path: '__e2e/detail-panel-utc-boundary', component: E2EDetailPanelUtcBoundaryHarnessPage },
  { path: '__e2e/detail-drawer', component: E2EDetailDrawerHarnessPage },
  { path: '__e2e/results-table', component: E2EResultsTableHarnessPage },
  { path: '__e2e/product-selections', component: E2EProductSelectionsHarnessPage },
  { path: '__e2e/synthetic-cancel', component: E2ESyntheticCancelHarnessPage },
];
